import { Component } from '@angular/core';

@Component({
  selector: 'app-termos-uso',
  templateUrl: './termos-de-uso.component.html',
  styleUrls: ['./termos-de-uso.component.css']
})
export class TermosUsoComponent {

}
